import { Button, Icon } from '@/shared'
import { EIcons } from '@App/types/iconType'

import style from './EmptyList.module.scss'

interface IAction {
    title: string
    callback: () => void
    icon: EIcons | null
    disabled: boolean
}

interface IProps {
    categoryId: string
    categoryName: string
    setAddSectionId: (addSectionId: string | null) => void
}

export const EmptyList = (props: IProps) => {
    const { categoryId, categoryName, setAddSectionId } = props

    const actions: IAction[] = [
        { title: 'Добавить раздел', callback: () => setAddSectionId(categoryId), icon: EIcons.PLUS, disabled: false }
        // { title: 'Добавить Услугу', callback: () => alert(categoryId), icon: EIcons.PLUS, disabled: false }
    ]

    const title = `В категории "${categoryName}" отсутствуют разделы или услуги`

    return (
        <div className={style.container}>
            <div className={style.header}>
                <span>{title}</span>
            </div>
            <div className={style.actions}>
                {actions.map((action) => {
                    const { title, callback, icon } = action
                    return (
                        <Button key={title} onClick={callback} disabled={false}>
                            <div>
                                {icon && <Icon iconName={icon} color='#fff' />}
                                <span>{title}</span>
                            </div>
                        </Button>
                    )
                })}
            </div>
        </div>
    )
}
